//---------------------------------------------------------------------Umaya 

// import React, { useState, useEffect } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { FaBell, FaCog } from 'react-icons/fa';
// import logoImage from '../assets/IMG2.png';
// import axios from 'axios';

// const LOCAL_STORAGE_VIEWED_KEY = 'viewedNotifications';
// const LOCAL_STORAGE_DELETED_KEY = 'deletedNotifications';

// const UserPageHeader = () => {
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [isNotificationDropdownOpen, setIsNotificationDropdownOpen] = useState(false);
//   const [isSettingsDropdownOpen, setIsSettingsDropdownOpen] = useState(false);
//   const [notifications, setNotifications] = useState([]);
//   const [selectedNotification, setSelectedNotification] = useState(null);
//   const navigate = useNavigate();

//   const toggleMobileMenu = () => setIsMobileMenuOpen((prev) => !prev);
//   const toggleNotificationDropdown = () => {
//     setIsNotificationDropdownOpen(!isNotificationDropdownOpen);
//     setIsSettingsDropdownOpen(false);
//   };
//   const toggleSettingsDropdown = () => {
//     setIsSettingsDropdownOpen(!isSettingsDropdownOpen);
//     setIsNotificationDropdownOpen(false);
//   };

//   const handleLogout = () => {
//     localStorage.removeItem('token');
//     navigate('/login');
//   };

//   const formatTimeAgo = (dateString) => {
//     const now = new Date();
//     const date = new Date(dateString);
//     const secondsAgo = Math.floor((now - date) / 1000);
//     if (secondsAgo < 5) return 'Just now';
//     if (secondsAgo < 60) return `${secondsAgo}s ago`;
//     const minutes = Math.floor(secondsAgo / 60);
//     if (minutes < 60) return `${minutes}m ago`;
//     const hours = Math.floor(minutes / 60);
//     if (hours < 24) return `${hours}h ago`;
//     const days = Math.floor(hours / 24);
//     return days === 1 ? 'Yesterday' : `${days}d ago`;
//   };

//   const loadViewed = () => JSON.parse(localStorage.getItem(LOCAL_STORAGE_VIEWED_KEY)) || [];
//   const loadDeleted = () => JSON.parse(localStorage.getItem(LOCAL_STORAGE_DELETED_KEY)) || [];
//   const saveViewed = (data) => localStorage.setItem(LOCAL_STORAGE_VIEWED_KEY, JSON.stringify(data));
//   const saveDeleted = (data) => localStorage.setItem(LOCAL_STORAGE_DELETED_KEY, JSON.stringify(data));

//   const fetchNotifications = async () => {
//     try {
//       const res = await axios.get('https://carrentalbackend.dockyardsoftware.com/api/Notifications');
//       const viewed = loadViewed();
//       const deleted = loadDeleted();
//       const filtered = res.data.filter(n => !deleted.includes(n.id)).map(n => ({
//         ...n,
//         viewed: viewed.includes(n.id)
//       }));
//       setNotifications(filtered);
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   const handleNotificationClick = (notif) => {
//     setSelectedNotification(notif);
//     if (!notif.viewed) {
//       const updated = notifications.map(n => n.id === notif.id ? { ...n, viewed: true } : n);
//       setNotifications(updated);
//       const viewed = loadViewed();
//       viewed.push(notif.id);
//       saveViewed([...new Set(viewed)]);
//     }
//   };

//   const handleDeleteNotification = (id) => {
//     setNotifications(notifications.filter(n => n.id !== id));
//     const deleted = [...new Set([...loadDeleted(), id])];
//     saveDeleted(deleted);
//     const viewed = loadViewed().filter(v => v !== id);
//     saveViewed(viewed);
//   };

//   useEffect(() => {
//     fetchNotifications();
//   }, []);

//   const unreadCount = notifications.filter(n => !n.viewed).length;

//   return (
//     <header className="sticky -top-20 z-50 bg-white shadow-lg rounded-b-2xl">
//       <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
//         {/* Left: Logo */}
//         <div className="flex items-center space-x-3">
//           <img src={logoImage} alt="Logo" className="h-10 w-auto rounded-lg" />
//           <span className="text-lg font-semibold text-gray-800 hidden sm:block">Car Rental</span>
//         </div>

//         {/* Desktop Menu */}
//         <nav className="hidden md:flex space-x-6 text-sm font-medium">
//           <Link to="/userpage" className="hover:text-blue-600 rounded-lg px-3 py-1 transition">Home</Link>
//           <Link to="/about-us" className="hover:text-blue-600 rounded-lg px-3 py-1 transition">About Us</Link>
//           <Link to="/contact-us" className="hover:text-blue-600 rounded-lg px-3 py-1 transition">Contact</Link>
//         </nav>

//         {/* Icons and Hamburger */}
//         <div className="flex items-center gap-4">
//           {/* Bell */}
//           <div className="relative cursor-pointer" onClick={toggleNotificationDropdown}>
//             <FaBell className="text-xl text-gray-700 hover:text-blue-600" />
//             {unreadCount > 0 && (
//               <span className="absolute -top-1 -right-1 bg-blue-600 text-white text-xs rounded-full px-1">
//                 {unreadCount}
//               </span>
//             )}
//             {isNotificationDropdownOpen && (
//               <div className="absolute right-0 mt-2 w-80 bg-white rounded-md shadow-lg border border-gray-200 z-50 max-h-[400px] overflow-y-auto">
//                 <div className="px-4 py-3 border-b">
//                   <h3 className="text-sm font-semibold text-gray-900">Notifications</h3>
//                 </div>
//                 <ul className="p-2 space-y-2">
//                   {notifications.map(notification => (
//                     <li key={notification.id} className="flex justify-between items-start hover:bg-gray-50 rounded-md p-2">
//                       <div className="flex items-center gap-3 cursor-pointer" onClick={() => handleNotificationClick(notification)}>
//                         {!notification.viewed && <span className="w-2 h-2 bg-blue-600 rounded-full"></span>}
//                         {/* <img src={notification.avatar || 'https://via.placeholder.com/40'} className="w-10 h-10 rounded-full" alt="avatar" /> */}
//                         <div className="text-sm">
//                           <p className="font-semibold text-gray-900">{notification.sender || 'Car Rental'}</p>
//                           <p className="text-gray-500">{notification.message}</p>
//                           <span className="text-xs text-gray-400">{formatTimeAgo(notification.dateCreated)}</span>
//                         </div>
//                       </div>
//                       <button className="text-red-500 hover:text-red-700 ml-2" onClick={() => handleDeleteNotification(notification.id)}>✕</button>
//                     </li>
//                   ))}
//                   {notifications.length === 0 && <p className="text-center text-gray-500 py-4">No notifications</p>}
//                 </ul>
//               </div>
//             )}
//           </div>

//           {/* Settings */}
//           <div className="relative cursor-pointer" onClick={toggleSettingsDropdown}>
//             <FaCog className="text-xl text-gray-700 hover:text-blue-600" />
//             {isSettingsDropdownOpen && (
//               <div className="absolute right-0 mt-2 w-80 bg-white rounded-md shadow-lg border border-gray-200 z-50 max-h-[400px] overflow-y-auto">
//                  <div className="px-4 py-3 border-b">
//                   <h3 className="text-sm font-semibold text-gray-900">Settings</h3>
//                 </div>
//                 <ul className="text-sm py-2">
//                   <li><Link to="/appointment-history" className="block px-4 py-2 hover:bg-gray-100">Booking History</Link></li>
//                   <li><button onClick={handleLogout} className="block w-full text-left px-4 py-2 hover:bg-gray-100">Logout</button></li>
//                 </ul>
//               </div>
//             )}
//           </div>

//           {/* Hamburger - Mobile */}
//           <div className="md:hidden">
//             <button onClick={toggleMobileMenu}>
//               <svg className="h-6 w-6 text-gray-800" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 {isMobileMenuOpen ? (
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                 ) : (
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
//                 )}
//               </svg>
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* Mobile Nav */}
//       {isMobileMenuOpen && (
//         <div className="md:hidden bg-white border-t border-gray-200 rounded-b-2xl shadow-lg">
//           <nav className="flex flex-col space-y-1 px-4 py-3 text-sm font-medium">
//             <Link to="/userpage" onClick={toggleMobileMenu} className="py-2 px-3 rounded-lg hover:bg-blue-50">Home</Link>
//             <Link to="/about-us" onClick={toggleMobileMenu} className="py-2 px-3 rounded-lg hover:bg-blue-50">About Us</Link>
//             <Link to="/contact-us" onClick={toggleMobileMenu} className="py-2 px-3 rounded-lg hover:bg-blue-50">Contact</Link>
//           </nav>
//         </div>
//       )}

//       {/* Notification Modal */}
//       {selectedNotification && (
//         <div className="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-50">
//           <div className="bg-white p-4 rounded-md shadow-md w-96">
//             <p className="mb-4">{selectedNotification.message}</p>
//             <button onClick={() => setSelectedNotification(null)} className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">Close</button>
//           </div>
//         </div>
//       )}
//     </header>
//   );
// };

// export default UserPageHeader;





//-----------------------------------------------------------Sachith-----------------------------------------------





import React, { useState, useEffect, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaBell, FaCog, FaUserCircle, FaSearch } from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';
import logoImage from '../assets/IMG2.png';
import axios from 'axios';
import { debounce } from 'lodash';
import { AuthContext } from '../Context/AuthContext';

const LOCAL_STORAGE_VIEWED_KEY = 'viewedNotifications';
const LOCAL_STORAGE_DELETED_KEY = 'deletedNotifications';

const UserPageHeader = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isNotificationDropdownOpen, setIsNotificationDropdownOpen] = useState(false);
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [selectedNotification, setSelectedNotification] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [isScrolled, setIsScrolled] = useState(false);

  const navigate = useNavigate();
  const { user } = useContext(AuthContext); // ✅ moved inside component

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => setIsMobileMenuOpen((prev) => !prev);

  const toggleNotificationDropdown = () => {
    setIsNotificationDropdownOpen(!isNotificationDropdownOpen);
    setIsProfileDropdownOpen(false);
    setIsMobileSearchOpen(false);
  };

  const toggleProfileDropdown = () => {
    setIsProfileDropdownOpen(!isProfileDropdownOpen);
    setIsNotificationDropdownOpen(false);
    setIsMobileSearchOpen(false);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  const formatTimeAgo = (dateString) => {
    const now = new Date();
    const date = new Date(dateString);
    const secondsAgo = Math.floor((now - date) / 1000);
    if (secondsAgo < 5) return 'Just now';
    if (secondsAgo < 60) return `${secondsAgo}s ago`;
    const minutes = Math.floor(secondsAgo / 60);
    if (minutes < 60) return `${minutes}m ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours}h ago`;
    const days = Math.floor(hours / 24);
    return days === 1 ? 'Yesterday' : `${days}d ago`;
  };

  const loadViewed = () => JSON.parse(localStorage.getItem(LOCAL_STORAGE_VIEWED_KEY)) || [];
  const loadDeleted = () => JSON.parse(localStorage.getItem(LOCAL_STORAGE_DELETED_KEY)) || [];
  const saveViewed = (data) => localStorage.setItem(LOCAL_STORAGE_VIEWED_KEY, JSON.stringify(data));
  const saveDeleted = (data) => localStorage.setItem(LOCAL_STORAGE_DELETED_KEY, JSON.stringify(data));

  const fetchNotifications = debounce(async () => {
    try {
      const res = await axios.get('https://carrentalbackend.dockyardsoftware.com/api/Notifications');
      const viewed = loadViewed();
      const deleted = loadDeleted();
      const filtered = res.data
        .filter(n => !deleted.includes(n.id))
        .map(n => ({
          ...n,
          viewed: viewed.includes(n.id)
        }));
      setNotifications(filtered);
    } catch (err) {
      console.error(err);
    }
  }, 300);

  const handleNotificationClick = (notif) => {
    setSelectedNotification(notif);
    setIsNotificationDropdownOpen(false);
    if (!notif.viewed) {
      const updated = notifications.map(n => n.id === notif.id ? { ...n, viewed: true } : n);
      setNotifications(updated);
      const viewed = loadViewed();
      viewed.push(notif.id);
      saveViewed([...new Set(viewed)]);
    }
  };

  const handleDeleteNotification = (id) => {
    setNotifications(notifications.filter(n => n.id !== id));
    const deleted = [...new Set([...loadDeleted(), id])];
    saveDeleted(deleted);
    const viewed = loadViewed().filter(v => v !== id);
    saveViewed(viewed);
  };

  useEffect(() => {
    fetchNotifications();
    return () => fetchNotifications.cancel();
  }, []);

  const unreadCount = notifications.filter(n => !n.viewed).length;

  return (
    <>
      {/* Curved background shape */}
      <div className="fixed top-0 w-full h-31 -z-10">
        <svg
          className="absolute inset-0 w-full h-full"
          viewBox="0 0 1200 200"
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient id="headerGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="rgba(59, 130, 246, 0.95)" />
              <stop offset="50%" stopColor="rgba(99, 102, 241, 0.9)" />
              <stop offset="100%" stopColor="rgba(168, 85, 247, 0.85)" />
            </linearGradient>
            <filter id="blur">
              <feGaussianBlur stdDeviation="0.5" />
            </filter>
          </defs>
          <path
            d="M0,0 L1200,0 L1200,120 Q900,180 600,140 Q300,100 0,160 Z"
            fill="url(#headerGradient)"
            filter="url(#blur)"
          />
        </svg>
      </div>

      <header className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        isScrolled 
          ? 'backdrop-blur-xl bg-white/80 shadow-2xl shadow-blue-500/10' 
          : 'backdrop-blur-sm bg-white/60'
      }`}
        style={{
          background: isScrolled 
            ? 'rgba(255, 255, 255, 0.85)' 
            : 'linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.7) 100%)',
          backdropFilter: 'blur(20px)',
          borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
        }}
      >
        <div className="mx-auto max-w-8xl px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20 md:h-24">
            {/* Left: Logo - moved slightly right */}
            <div className="flex-shrink-0 ml-4 md:ml-8">
              <Link to="/userpage" className="flex items-center space-x-4 group">
                <motion.div
                  className="relative"
                  whileHover={{ scale: 1.1, rotate: 5 }}
                  transition={{ type: "spring", stiffness: 300 }}
                >
                  <div className="absolute inset-0 bg-gradient-to-r from-blue-400 to-purple-500 rounded-2xl blur-lg opacity-30 group-hover:opacity-50 transition-opacity"></div>
                  <img
                    src={logoImage}
                    alt="Logo"
                    className="relative h-12 w-auto rounded-2xl shadow-lg border border-white/20"
                    loading="lazy"
                  />
                </motion.div>
                <span className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-blue-600 via-purple-600 to-blue-800 bg-clip-text text-transparent hidden sm:block">
                  CarRental
                </span>
              </Link>
            </div>

            {/* Center: Navigation - positioned more to the right */}
            <nav className="hidden md:flex space-x-2 flex-1 justify-center ml-24">
              {[
                { to: "/userpage", label: "Home" },
                { to: "/appointment-history", label: "Booking" },
                { to: "/about-us", label: "About Us" },
                { to: "/contact-us", label: "Contact" },
              ].map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  className="relative px-6 py-3 rounded-2xl font-medium text-gray-700 hover:text-white transition-all duration-300 group overflow-hidden"
                >
                  <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-purple-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl"></div>
                  <div className="absolute inset-0 bg-white/20 backdrop-blur-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl"></div>
                  <span className="relative z-10">{item.label}</span>
                </Link>
              ))}
            </nav>

            {/* Right: Search and Actions - moved further right */}
            <div className="flex items-center gap-6 mr-4 md:mr-8">
              {/* Search Bar - Desktop - moved right */}
              {/* <div className="hidden md:flex items-center max-w-sm">
                <div className="relative w-full">
                  <div className="absolute inset-0 bg-white/30 backdrop-blur-md rounded-3xl"></div>
                  <input
                    type="text"
                    placeholder="Search cars..."
                    className="relative w-full pl-6 pr-12 py-3 rounded-3xl border border-white/30 bg-white/20 backdrop-blur-md focus:outline-none focus:ring-2 focus:ring-blue-400/50 focus:border-transparent text-gray-700 placeholder-gray-500"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    aria-label="Search cars"
                    style={{
                      background: 'rgba(255, 255, 255, 0.25)',
                      backdropFilter: 'blur(10px)',
                    }}
                  />
                  <div className="absolute right-4 top-1/2 transform -translate-y-1/2 p-1.5 rounded-full bg-gradient-to-r from-blue-500 to-purple-600">
                    <FaSearch className="text-white text-sm" />
                  </div>
                </div>
              </div> */}

              {/* Mobile Search Button */}
              <button
                onClick={() => setIsMobileSearchOpen(!isMobileSearchOpen)}
                className="md:hidden p-3 rounded-2xl bg-white/20 backdrop-blur-md border border-white/30 text-gray-700 hover:text-blue-600 hover:bg-white/30 transition-all duration-300"
                aria-label="Toggle search bar"
                aria-expanded={isMobileSearchOpen}
              >
                <FaSearch className="text-lg" />
              </button>

              {/* Notification Dropdown */}
              <div className="relative">
                <button
                  onClick={toggleNotificationDropdown}
                  className="relative p-3 rounded-2xl bg-white/20 backdrop-blur-md border border-white/30 hover:bg-white/30 transition-all duration-300 group"
                  aria-label="Toggle notifications"
                  aria-expanded={isNotificationDropdownOpen}
                >
                  <FaBell className="text-lg text-gray-700 group-hover:text-blue-600 transition-colors" />
                  {unreadCount > 0 && (
                    <span className="absolute -top-1 -right-1 bg-gradient-to-r from-red-500 to-pink-500 text-white text-xs rounded-full w-6 h-6 flex items-center justify-center font-bold shadow-lg">
                      {unreadCount}
                    </span>
                  )}
                </button>

                <AnimatePresence>
                  {isNotificationDropdownOpen && (
                    <motion.div
                      initial={{ opacity: 0, scale: 0.95, y: 10 }}
                      animate={{ opacity: 1, scale: 1, y: 0 }}
                      exit={{ opacity: 0, scale: 0.95, y: 10 }}
                      className="absolute right-0 mt-3 w-80 sm:w-96 rounded-3xl shadow-2xl border border-white/20 z-50 overflow-hidden"
                      style={{
                        background: 'rgba(255, 255, 255, 0.95)',
                        backdropFilter: 'blur(20px)',
                      }}
                    >
                      <div className="px-6 py-4 border-b border-white/20 bg-gradient-to-r from-blue-50/50 to-purple-50/50">
                        <h3 className="text-lg font-bold text-gray-900">Notifications</h3>
                      </div>
                      <div className="max-h-80 overflow-y-auto">
                        <ul className="divide-y divide-white/20">
                          {notifications.length > 0 ? (
                            notifications.map(notification => (
                              <li
                                key={notification.id}
                                className={`flex justify-between items-start p-4 hover:bg-blue-50/50 transition-colors ${!notification.viewed ? 'bg-blue-50/30' : ''}`}
                              >
                                <div
                                  className="flex items-start gap-3 w-full cursor-pointer"
                                  onClick={() => handleNotificationClick(notification)}
                                >
                                  <div className="flex-shrink-0">
                                    <div className="w-12 h-12 rounded-2xl bg-gradient-to-r from-blue-500 to-purple-600 flex items-center justify-center shadow-lg">
                                      <span className="text-white text-lg font-bold">
                                        {notification.sender?.charAt(0) || 'C'}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="flex-1 min-w-0">
                                    <p className="text-sm font-semibold text-gray-900 mb-1">
                                      {notification.sender || 'Car Rental'}
                                    </p>
                                    <p className="text-sm text-gray-600 mb-1 line-clamp-2">
                                      {notification.message}
                                    </p>
                                    <span className="text-xs text-gray-400">
                                      {formatTimeAgo(notification.dateCreated)}
                                    </span>
                                  </div>
                                </div>
                                <button
                                  className="text-gray-400 hover:text-red-500 ml-2 transition-colors p-2 rounded-full hover:bg-red-50 flex-shrink-0"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleDeleteNotification(notification.id);
                                  }}
                                  aria-label={`Delete notification from ${notification.sender || 'Car Rental'}`}
                                >
                                  ✕
                                </button>
                              </li>
                            ))
                          ) : (
                            <li className="text-center text-gray-500 py-8">No notifications</li>
                          )}
                        </ul>
                      </div>
                      {notifications.length > 0 && (
                        <div className="px-6 py-4 border-t border-white/20 text-center bg-gradient-to-r from-blue-50/30 to-purple-50/30">
                          <button
                            className="text-sm text-blue-600 hover:text-blue-800 font-medium px-4 py-2 rounded-2xl hover:bg-blue-100/50 transition-colors"
                            onClick={() => {
                              const viewed = [...new Set([...loadViewed(), ...notifications.map(n => n.id)])];
                              saveViewed(viewed);
                              setNotifications(notifications.map(n => ({ ...n, viewed: true })));
                            }}
                          >
                            Mark all as read
                          </button>
                        </div>
                      )}
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>

              {/* Profile */}
              <div className="relative">
                <button
                  onClick={toggleProfileDropdown}
                  className="flex items-center space-x-3 p-2 rounded-2xl bg-white/20 backdrop-blur-md border border-white/30 hover:bg-white/30 transition-all duration-300 group"
                  aria-label="Toggle profile menu"
                  aria-expanded={isProfileDropdownOpen}
                >
                  <div className="w-10 h-10 rounded-2xl bg-gradient-to-r from-blue-500 via-purple-500 to-blue-600 flex items-center justify-center text-white shadow-lg">
                    <FaUserCircle className="text-xl" />
                  </div>
                  <span className="hidden lg:inline text-sm font-medium text-gray-700 group-hover:text-blue-600 transition-colors">
                    {user?.username || 'My Account'}
                  </span>
                </button>
 
                <AnimatePresence>
                  {isProfileDropdownOpen && (
                    <motion.div
                      initial={{ opacity: 0, scale: 0.95, y: 10 }}
                      animate={{ opacity: 1, scale: 1, y: 0 }}
                      exit={{ opacity: 0, scale: 0.95, y: 10 }}
                      className="absolute right-0 mt-3 w-48 rounded-3xl shadow-2xl border border-white/20 z-50 overflow-hidden"
                      style={{
                        background: 'rgba(255, 255, 255, 0.95)',
                        backdropFilter: 'blur(20px)',
                      }}
                    >
                      <div className="py-2">
                        {[
                          { to: "/user-profile", label: "Profile" },
                          { to: "/appointment-history", label: "Booking History" },
                          //{ to: "/settings", label: "Settings" },
                        ].map((item) => (
                          <Link
                            key={item.to}
                            to={item.to}
                            className="block px-4 py-3 text-sm text-gray-700 hover:bg-blue-50/50 hover:text-blue-600 transition-colors rounded-2xl mx-2"
                          >
                            {item.label}
                          </Link>
                        ))}
                        <hr className="border-white/20 my-2 mx-2" />
                        <button
                          onClick={handleLogout}
                          className="w-full text-left px-4 py-3 text-sm text-gray-700 hover:bg-red-50/50 hover:text-red-600 transition-colors rounded-2xl mx-2"
                          aria-label="Logout"
                        >
                          Logout
                        </button>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>

              {/* Hamburger - Mobile */}
              <button
                onClick={toggleMobileMenu}
                className="md:hidden p-3 rounded-2xl bg-white/20 backdrop-blur-md border border-white/30 hover:bg-white/30 transition-all duration-300"
                aria-label="Toggle mobile menu"
                aria-expanded={isMobileMenuOpen}
              >
                <motion.div
                  animate={{ rotate: isMobileMenuOpen ? 45 : 0 }}
                  transition={{ duration: 0.2 }}
                >
                  {isMobileMenuOpen ? (
                    <svg className="h-6 w-6 text-gray-800" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  ) : (
                    <svg className="h-6 w-6 text-gray-800" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                    </svg>
                  )}
                </motion.div>
              </button>
            </div>
          </div>

          {/* Mobile Search Bar */}
          <AnimatePresence>
            {isMobileSearchOpen && (
              <motion.div
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: 'auto' }}
                exit={{ opacity: 0, height: 0 }}
                className="pb-4 md:hidden"
              >
                <div className="relative mx-4">
                  <div className="absolute inset-0 bg-white/30 backdrop-blur-md rounded-3xl"></div>
                  <input
                    type="text"
                    placeholder="Search cars..."
                    className="relative w-full pl-6 pr-12 py-3 rounded-3xl border border-white/30 bg-white/20 backdrop-blur-md focus:outline-none focus:ring-2 focus:ring-blue-400/50 focus:border-transparent text-gray-700 placeholder-gray-500"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    aria-label="Search cars"
                    style={{
                      background: 'rgba(255, 255, 255, 0.25)',
                      backdropFilter: 'blur(10px)',
                    }}
                  />
                  <div className="absolute right-4 top-1/2 transform -translate-y-1/2 p-1.5 rounded-full bg-gradient-to-r from-blue-500 to-purple-600">
                    <FaSearch className="text-white text-sm" />
                  </div>
                </div>
              </motion.div>
            )}
          </AnimatePresence>

          {/* Mobile Menu */}
          <AnimatePresence>
            {isMobileMenuOpen && (
              <motion.div
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: 'auto' }}
                exit={{ opacity: 0, height: 0 }}
                className="md:hidden overflow-hidden"
                style={{
                  background: 'rgba(255, 255, 255, 0.95)',
                  backdropFilter: 'blur(20px)',
                  borderRadius: '0 0 24px 24px',
                }}
              >
                <div className="px-4 pt-2 pb-6 space-y-3">
                  {[
                    { to: "/userpage", label: "Home" },
                    { to: "/about-us", label: "About Us" },
                    { to: "/contact-us", label: "Contact" },
                    { to: "/appointment-history", label: "Booking History" },
                  ].map((item) => (
                    <Link
                      key={item.to}
                      to={item.to}
                      onClick={toggleMobileMenu}
                      className="block px-4 py-3 rounded-2xl font-medium text-gray-700 hover:text-blue-600 hover:bg-blue-50/50 transition-all duration-300"
                    >
                      {item.label}
                    </Link>
                  ))}
                  <button
                    onClick={() => {
                      toggleMobileMenu();
                      handleLogout();
                    }}
                    className="w-full text-left px-4 py-3 rounded-2xl font-medium text-gray-700 hover:text-red-600 hover:bg-red-50/50 transition-all duration-300 border-t border-white/20 mt-2"
                    aria-label="Logout"
                  >
                    Logout
                  </button>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>

        {/* Single Notification Modal */}
        <AnimatePresence>
          {selectedNotification && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="fixed inset-0 bg-black/40 backdrop-blur-sm flex justify-center items-center z-50 p-4"
              onClick={() => setSelectedNotification(null)}
            >
              <motion.div
                initial={{ scale: 0.9, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0.9, opacity: 0 }}
                className="max-w-full w-full sm:max-w-lg overflow-hidden rounded-3xl shadow-2xl"
                onClick={(e) => e.stopPropagation()}
                style={{
                  background: 'rgba(255, 255, 255, 0.95)',
                  backdropFilter: 'blur(20px)',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                }}
              >
                <div className="p-6">
                  <div className="flex items-start mb-6">
                    <div className="flex-shrink-0 mr-4">
                      <div className="w-16 h-16 rounded-3xl bg-gradient-to-r from-blue-500 to-purple-600 flex items-center justify-center shadow-lg">
                        <span className="text-white text-2xl font-bold">
                          {selectedNotification.sender?.charAt(0) || 'C'}
                        </span>
                      </div>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-900 mb-1">
                        {selectedNotification.sender || 'Car Rental'}
                      </h3>
                      <p className="text-sm text-gray-500">
                        {formatTimeAgo(selectedNotification.dateCreated)}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gradient-to-r from-blue-50/50 to-purple-50/50 p-6 rounded-3xl mb-6 border border-white/20">
                    <p className="text-gray-700 whitespace-pre-wrap">
                      {selectedNotification.message}
                    </p>
                  </div>
                  <div className="flex justify-end space-x-3">
                    <button
                      onClick={() => {
                        handleDeleteNotification(selectedNotification.id);
                        setSelectedNotification(null);
                      }}
                      className="px-6 py-3 text-red-600 hover:bg-red-50/50 rounded-2xl transition-colors border border-red-200/50"
                      aria-label="Delete notification"
                    >
                      Delete
                    </button>
                    <button
                      onClick={() => setSelectedNotification(null)}
                      className="px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-2xl hover:from-blue-700 hover:to-purple-700 transition-all duration-300 shadow-lg"
                      aria-label="Close notification"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </header>
    </>
  );
};

export default UserPageHeader;